/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

export const getWalletTopUpStatus = state =>
  state && state.topUp && state.topUp.status ? state.topUp.status : false;
export const getWalletTopUpLoading = state =>
  state && state.topUp && state.topUp.loading ? state.topUp.loading : false;
export const getMyWalletItem = state =>
  state && state.wallet && state.wallet.item ? state.wallet.item : null;
export const getMyWalletLoading = state =>
  state && state.wallet && state.wallet.loading ? state.wallet.loading : false;
export const getWalletPaymentHistoryListItems = state =>
  state &&
  state.paymentHistory &&
  state.paymentHistory.list &&
  state.paymentHistory.list.items
    ? state.paymentHistory.list.items
    : [];
export const getWalletPaymentHistoryPagination = state =>
  state &&
  state.paymentHistory &&
  state.paymentHistory.list &&
  state.paymentHistory.list.pagination
    ? state.paymentHistory.list.pagination
    : null;
export const getWalletPaymentHistoryLoading = state =>
  state && state.paymentHistory && state.paymentHistory.loading
    ? state.paymentHistory.loading
    : false;
export const getWalletPaymentHistoryHideLoading = state =>
  state && state.paymentHistory && state.paymentHistory.hideLoading
    ? state.paymentHistory.hideLoading
    : false;
export const getWalletTopUpCreatePaymentItem = state =>
  state &&
  state.topUp &&
  state.topUp.createPayment &&
  state.topUp.createPayment.item
    ? state.topUp.createPayment.item
    : null;
export const getWalletUpdateTopUpPaymentStatus = state =>
  state && state.updateTopUpPayment && state.updateTopUpPayment.status
    ? state.updateTopUpPayment.status
    : false;

// wallet
export const getWalletID = wallet => (wallet && wallet.id ? wallet.id : null);
export const getWalletBalance = wallet =>
  wallet && wallet.balance ? wallet.balance : 0;
export const getWalletCurrency = wallet =>
  wallet && wallet.currency && wallet.currency.symbol
    ? wallet.currency.symbol
    : "RM";
export const getWalletWithdrawable = wallet =>
  wallet && wallet.withdrawable ? wallet.withdrawable : 0;
export const getWalletWithdrawInProgress = wallet =>
  wallet && wallet.withdraw_in_progress ? wallet.withdraw_in_progress : 0;

// transaction
export const getWalletTransactionDescription = transaction =>
  transaction && transaction.description ? transaction.description : "";
export const getWalletTransactionAmountText = transaction =>
  transaction && transaction.amount && transaction.amount.text
    ? transaction.amount.text
    : "";
export const getWalletTransactionTypeName = transaction =>
  transaction && transaction.type && transaction.type.name
    ? transaction.type.name
    : "";
export const getWalletTransactionCreatedDateTimeRelative = transaction =>
  transaction &&
  transaction.created_datetime &&
  transaction.created_datetime.relative
    ? transaction.created_datetime.relative
    : "";



// WEBPACK FOOTER //
// ./src/selectors/wallet.js